import { useCallback } from 'react';
import qs from 'query-string';
import { KAKAO_CLIENT_KEY, SNS_AUTH_DATA_KEY, getKakaoRedirectUrl, isSnsSignOut } from 'app/libs/snsUtils';
import { setSessionItem } from 'app/libs/storageUtils';
import useSsrUserAgent from 'app/hook/common/useSsrUserAgent';

export default function useAuthKakao() {
	const ua = useSsrUserAgent();

	const startAuth = useCallback(
		(state, reauthenticate) => {
			const baseQuery = {
				client_id: KAKAO_CLIENT_KEY,
				redirect_uri: getKakaoRedirectUrl(),
				response_type: 'code',
				state,
			};

			const queryString = reauthenticate ? { ...baseQuery, prompt: 'login' } : baseQuery;

			const query = qs.stringify(queryString);

			const continueUrl = encodeURIComponent(`https://kauth.kakao.com/oauth/authorize?${query}`);

			if (ua().isPc && isSnsSignOut('KAKAO')) {
				window.location.href = `https://accounts.kakao.com/login?continue=${continueUrl}`;
			} else {
				window.location.href = `https://kauth.kakao.com/oauth/authorize?${query}`;
			}
		},
		[ua],
	);

	/**
	 * 함수 호출시 아래와 같은 타입으로 파라미터를 전달해야 합니다.
	 * snsAuthorizeForTypes.LOGIN,
	 * snsAuthorizeForTypes.MY_INFO_ACCESS,
	 * snsAuthorizeForTypes.CONNECT_LOGIN
	 */
	const authorizeKakao = useCallback(
		async (type, options, reauthenticate = false) => {
			if (!type) throw new Error('인증 타입을 전달해 주세요.');

			try {
				const state = new Date().getTime();
				setSessionItem(SNS_AUTH_DATA_KEY, { type, state, options });
				startAuth(state, reauthenticate);
			} catch (err) {
				console.error(err);
			}
		},
		[startAuth],
	);

	return { authorizeKakao };
}
